import EmptyStatesPreview from '../content/EmptyStatesPreview'
import { ApiAccess } from '@eggplant/pattern-library/src/lib/components/Artwork/Artwork'
import { DaiAccessControl } from '@eggplant/context'
import { HiPlus } from 'react-icons/hi'
import { LinkButton } from '@eggplant/pattern-library'
import { LinkToAPIAccessDoc } from '../links'
import { LinkToAddSpaceApiAccess } from '@eggplant/routing'

const description = 'API access keys can be generated to enable direct API requests to our service endpoints for use with third party clients.'

const renderButton = () =>
  <DaiAccessControl
    allowedRoles={['dai:admin']}
    isHiddenIfDenied
  >
    <LinkButton variant='primary'>
      <LinkToAddSpaceApiAccess>
        <HiPlus
          aria-hidden
          size='19.2px'
        /> New API Access
      </LinkToAddSpaceApiAccess>
    </LinkButton>
  </DaiAccessControl>

const SpaceApiAccessIntro = () =>
  <div className='grid h-full justify-center'>
    <div className='grid w-[36em]'>
      <EmptyStatesPreview
        action={renderButton()}
        description={description}
        icon={<ApiAccess />}
        renderLink={<LinkToAPIAccessDoc />}
        title='API Access'
      />
    </div>
  </div>

export default SpaceApiAccessIntro
